module.exports = __webpack_public_path__ + "static/img/swiper-2.e3c24ca6.png";